export default "__VITE_ASSET__CZqWcTec__"